import { getAccessToken } from './auth'

export interface WorkspaceAccess {
  dev: boolean
  prod: boolean
}

/**
 * Probe each configured Databricks workspace to check whether the
 * current user's MSAL token grants access.  The server makes a
 * lightweight SCIM /Me call per workspace and returns a boolean map.
 */
export async function checkWorkspaceAccess(): Promise<WorkspaceAccess> {
  const token = await getAccessToken()
  const res = await fetch('/api/workspace-access', {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) {
    throw new Error(`Workspace access check failed (${res.status})`)
  }
  return res.json() as Promise<WorkspaceAccess>
}
